<template>
  <div class="all_part" @click="bar_notShow">
    <div class="head">
      <div class="back" v-show="this.$store.state.pan_CloseNotShow==0"></div>
      <div class="back" @click="back" v-show="this.$store.state.pan_CloseNotShow==1">
        <img src="../assets/main_menu_Phone/back.png" alt="" width="25px"/>
      </div>
      <div class="titleAndicon">
        <div class="titleName">
          <span>竞品信息登记</span>
        </div>
        <div class="title_icon" @click="navbarShow" @click.stop>
          <img src="../assets/ProductTablePhone_img/icon.png" alt="" width="30px"/>
        </div>
      </div>
    </div>
    <div class="heads" v-if="PanDuanShou">
      <div class="heads_menus" v-if="user_leave.standardType == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/JiaGeKuCun.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="Second_jiage">
          <span>价格与库存</span>
        </div>
      </div>
      <dir class="heads_menu" v-if="user_leave.master_gear == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/ICChanPinXinXi.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="Second_ZhuDang">
          <span>IC市场信息</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.competitive_products == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/NeiBuXieTiao.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="TableInputPhone">
          <span>IC市场情报</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.task == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/JiaGeKuCun.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="NeiBuXieTiao">
          <span>内部协调</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.financeType == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/YingShouKuanYuFaPiao.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="FinancePhone">
          <span>应收款与发票</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.orderType == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/YingShouKuanYuFaPiao.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="DingDanZhongXin">
          <span>订单中心</span>
        </div>
      </dir>
    </div>
    <div>
      <div class="ss"></div>
      <div class="all_input_control">
        <div class="all_control" v-if="this.$route.params.userId==1">
          <div class="all_control_input_button">
            <div class="Type_title">
              <span>竞品关联信息</span>
            </div>
            <div class="type_selection">
              <span>关联类型</span>
              <el-radio-group v-model="selectC">
                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                          :disabled="opt.id!=jinxuan" style=" margin-right: 15px;">
                  {{ opt.value }}
                </el-radio>
              </el-radio-group>
            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联企业</span>
                </div>
                <div class="all_input">
                  <el-select v-model="companyChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                             clearable @change="change('a', companyChoice)">
                    <el-option
                        v-for="item in companyTable"
                        :key="item.id"
                        :label="item.enterprise"
                        :value="{id:item.id, companyName:item.enterprise}"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <el-button @click="Pan_add_companyTable">新增</el-button>
                </div>
              </div>

            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联人员</span>
                </div>
                <div class="all_input">
                  <el-select v-model="staff_name_select" filterable placeholder="请选择" style="width: 200px"
                  >
                    <el-option
                        v-for="item in companyStaffTable"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <el-button @click="Pan_add_staff()">新增</el-button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="all_control" v-if=" this.$route.params.userId==1">
          <div class="all_control_input_button">
            <div class="Type_title">
              <span>FAB用户</span>
            </div>
            <div class="type_selection">
              <div>
                <span>关联类型</span>
              </div>
              <el-radio-group v-model="selectFAB">
                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                          :disabled="opt.id!=jinxuan3"style=" margin-right: 15px;">
                  {{ opt.value }}
                </el-radio>
              </el-radio-group>
            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联企业</span>
                </div>
                <div class="all_input">
                  <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                             clearable @change="change('b', FABcompanChoice)">
                    <el-option
                        v-for="item in FABcompanyTable"
                        :key="item.id"
                        :label="item.enterprise"
                        :value="{id:item.id, companyName:item.enterprise}"
                    >
                    </el-option>
                  </el-select>

                </div>
                <div>
                  <el-button @click="add_companyTable=2">新增</el-button>
                </div>
              </div>

            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联人员</span>
                </div>
                <div class="all_input">
                  <el-select v-model="FABstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                    <el-option
                        v-for="item in FABcompanyStaffTable"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <el-button @click="Pan_add_FABstaff">新增</el-button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="all_control" v-if=" this.$route.params.userId==3">
          <div class="all_control_input_button">
            <div class="Type_title">
              <span>FAB用户</span>
            </div>
            <div class="type_selection">
              <div>
                <span>关联类型</span>
              </div>
              <el-radio-group v-model="selectFAB">
                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                          :disabled="opt.id!=jinxuan" style=" margin-right: 15px;">
                  {{ opt.value }}
                </el-radio>
              </el-radio-group>
            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联企业</span>
                </div>
                <div class="all_input">
                  <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                             clearable @change="change('b', FABcompanChoice)">
                    <el-option
                        v-for="item in FABcompanyTable"
                        :key="item.id"
                        :label="item.enterprise"
                        :value="{id:item.id, companyName:item.enterprise}"
                    >
                    </el-option>
                  </el-select>

                </div>
                <div>
                  <el-button @click="add_companyTable=2">新增</el-button>
                </div>
              </div>

            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联人员</span>
                </div>
                <div class="all_input">
                  <el-select v-model="FABstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                    <el-option
                        v-for="item in FABcompanyStaffTable"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <el-button @click="Pan_add_FABstaff">新增</el-button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="all_control" v-if="  this.$route.params.userId==3">

          <div class="all_control_input_button">
            <div class="Type_title">
              <span>OEM设备商</span>
            </div>
            <div class="type_selection">
              <div>
                <span>关联类型</span>
              </div>
              <el-radio-group v-model="selectOEM">
                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                          :disabled="opt.id!=jinxuan4" style=" margin-right: 15px;">
                  {{ opt.value }}
                </el-radio>
              </el-radio-group>
            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联企业</span>
                </div>
                <div class="all_input">
                  <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                             clearable @change="change('c', OEMcompanyChoice)">
                    <el-option
                        v-for="item in OEMcompanyTable"
                        :key="item.id"
                        :label="item.enterprise"
                        :value="{id:item.id, companyName:item.enterprise}"
                    >
                    </el-option>
                  </el-select>

                </div>
                <div>
                  <el-button @click="add_companyTable=3">新增</el-button>
                </div>
              </div>

            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联人员</span>
                </div>
                <div class="all_input">
                  <el-select v-model="OEMstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                    <el-option
                        v-for="item in OEMcompanyStaffTable"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <el-button @click="Pan_add_OEMstaff">新增</el-button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="all_control" v-if="  this.$route.params.userId==5">

          <div class="all_control_input_button">
            <div class="Type_title">
              <span>OEM设备商</span>
            </div>
            <div class="type_selection">
              <div>
                <span>关联类型</span>
              </div>
              <el-radio-group v-model="selectOEMs">
                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                          :disabled="opt.id!=jinxuan" style=" margin-right: 15px;">
                  {{ opt.value }}
                </el-radio>
              </el-radio-group>
            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联企业</span>
                </div>
                <div class="all_input">
                  <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                             clearable @change="change('c', OEMcompanyChoice)">
                    <el-option
                        v-for="item in OEMcompanyTable"
                        :key="item.id"
                        :label="item.enterprise"
                        :value="{id:item.id, companyName:item.enterprise}"
                    >
                    </el-option>
                  </el-select>

                </div>
                <div>
                  <el-button @click="add_companyTable=3">新增</el-button>
                </div>
              </div>

            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联人员</span>
                </div>
                <div class="all_input">
                  <el-select v-model="OEMstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                    <el-option
                        v-for="item in OEMcompanyStaffTable"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <el-button @click="Pan_add_OEMstaff">新增</el-button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="all_control" v-if="this.$route.params.userId==5">
          <div class="all_control_input_button">
            <div class="Type_title">
              <span>竞品关联信息</span>
            </div>
            <div class="type_selection">
              <div>
                <span>关联类型</span>
              </div>
              <div v-if="this.$route.params.userId!=5">
                <el-radio-group v-model="selectC">
                  <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                            :disabled="opt.id!=jinxuan2" style=" margin-right: 15px;">
                    {{ opt.value }}
                  </el-radio>
                </el-radio-group>
              </div>
              <div v-if="this.$route.params.userId==5">
                <el-radio-group v-model="selectC">
                  <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                            :disabled="opt.id!=jinxuan2" style=" margin-right: 15px;">
                    {{ opt.value }}
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联企业</span>
                </div>
                <div class="all_input">
                  <el-select v-model="companyChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                             clearable @change="change('a', companyChoice)">
                    <el-option
                        v-for="item in companyTable"
                        :key="item.id"
                        :label="item.enterprise"
                        :value="{id:item.id, companyName:item.enterprise}"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <el-button @click="Pan_add_companyTable">新增</el-button>
                </div>
              </div>

            </div>
            <div>
              <div class="title_input_button">
                <div class="titles">
                  <span>关联人员</span>
                </div>
                <div class="all_input">
                  <el-select v-model="staff_name_select" filterable placeholder="请选择" style="width: 200px"
                  >
                    <el-option
                        v-for="item in companyStaffTable"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <el-button @click="Pan_add_staff()">新增</el-button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="all_input_controls">
        <div class="all_controls">
          <div class="all_control_input_buttons">
            <div class="all_control_input_buttons_textar">
              <div class="left">
                <div class="Type_title">
                  <span>竞品&设备&制程</span>
                </div>
                <div>
                  <div class="title_input_button" v-show="this.$route.params.userId!=1">
                    <div class="titles">
                      <span>设备型号</span>
                    </div>
                    <div class="all_input">

                      <el-select v-model="deviceChoice" filterable placeholder="请选择" style="width: 200px" clearable
                                 @change="change('d', companyChoice)">
                        <el-option
                            v-for="item in deviceTable"
                            :key="item.value"
                            :label="item.device_type"
                            :value="item.device_type">
                        </el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-button @click="Pan_add_device_type">新增</el-button>
                    </div>
                  </div>

                </div>
                <div>
                  <div class="title_input_button">
                    <div class="titles">
                      <span>制程工艺</span>
                    </div>
                    <div class="all_input">

                      <el-select v-model="processChoice" filterable placeholder="请选择" style="width: 200px">
                        <el-option
                            v-for="item in processTable"
                            :key="item.value"
                            :label="item.process_technology"
                            :value="item.process_technology">
                        </el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-button @click="Pan_add_process">新增</el-button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="title_input_button">
                    <div class="titles">
                      <span>竞品类别</span>
                    </div>
                    <div class="all_input">

                      <el-select v-model="categoryChoice" filterable placeholder="请选择" style="width: 200px">
                        <el-option
                            v-for="item in categoryTable"
                            :key="item.value"
                            :label="item.title"
                            :value="item.title">
                        </el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-button @click="Pan_add_category">新增</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="lefts">

                <div class="title_input_buttons">
                  <div class="titles">
                    <span>竞品&设备情况</span>
                  </div>
                  <div class="all_input">
                    <el-input
                        style=""
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="textarea">
                    </el-input>
                  </div>

                </div>
                <div class="title_input_buttons">
                  <div class="titles">
                    <span>人员关系&活动</span>
                  </div>
                  <div class="all_input">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="textarea">
                    </el-input>
                  </div>
                </div>
                <div class="Login_button">
                  <el-upload
                      class="upload-demo"
                      action="http://hairong.zhongqinchina.com/api/up_files/upload"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      :before-upload="beforeAvatarUpload"
                      :on-success="urlChange"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList">
                    <el-button type="primary" style="width: 200px;margin-bottom:10px">点击上传</el-button>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button_update">
        <el-button type="primary" style="height: 45px; width: 200px" @click="updateAll"
        >点击提交
        </el-button
        >
      </div>
      <div class="add_info" v-if="add_staff_type===1">
        <div class="add_staff_info_titleAndInput">
          <span>企业</span>
          <el-input style="width: 200px" :value="companyChoice.companyName" :disabled="false"
                    :v-model="staff_companyChoice=companyChoice.id"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>姓名</span>
          <el-input style="width: 200px" v-model="staff_Name"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>手机号</span>
          <el-input style="width: 200px" v-model="staff_phone"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>微信</span>
          <el-input style="width: 200px" v-model="staff_wechart"></el-input>
        </div>
        <div class="add_info_button">
          <el-button @click="addStaff">添加</el-button>
          <el-button @click="Pan_add_staff">返回</el-button>
        </div>
      </div>
      <div class="add_info" v-if="add_companyTable===1">
        <div class="add_staff_info_titleAndInput">
          <span>企业名称</span>
          <el-input style="width: 200px" v-model="add_company_name"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>简称</span>
          <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>
        </div>
        <div class="add_info_button">
          <el-button @click="addcompany">添加</el-button>
          <el-button @click="Pan_add_companyTable">返回</el-button>
        </div>
      </div>
      <div class="add_info" v-if="add_staff_type===2">
        <div class="add_staff_info_titleAndInput">
          <span>企业</span>
          <el-input style="width: 200px" :value="FABcompanChoice.companyName" :disabled="false"
                    :v-model="staff_companyChoice=FABcompanChoice.id"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>姓名</span>
          <el-input style="width: 200px" v-model="staff_Name"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>手机号</span>
          <el-input style="width: 200px" v-model="staff_phone"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>微信</span>
          <el-input style="width: 200px" v-model="staff_wechart"></el-input>
        </div>
        <div class="add_info_button">
          <el-button @click="addFABStaff">添加</el-button>
          <el-button @click="Pan_add_staff">返回</el-button>
        </div>
      </div>
      <div class="add_info" v-if="add_companyTable===2">
        <div class="add_staff_info_titleAndInput">
          <span>企业名称</span>
          <el-input style="width: 200px" v-model="add_company_name"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>简称</span>
          <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>
        </div>
        <div class="add_info_button">
          <el-button @click="addFABcompany">添加</el-button>
          <el-button @click="Pan_add_companyTable">返回</el-button>
        </div>
      </div>
      <div class="add_info" v-if="add_staff_type===3">
        <div class="add_staff_info_titleAndInput">
          <span>企业</span>
          <el-input style="width: 200px" :value="OEMcompanyChoice.companyName" :disabled="false"
                    :v-model="staff_companyChoice=OEMcompanyChoice.id"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>姓名</span>
          <el-input style="width: 200px" v-model="staff_Name"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>手机号</span>
          <el-input style="width: 200px" v-model="staff_phone"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>微信</span>
          <el-input style="width: 200px" v-model="staff_wechart"></el-input>
        </div>
        <div class="add_info_button">
          <el-button @click="addOEMStaff">添加</el-button>
          <el-button @click="Pan_add_staff">返回</el-button>
        </div>
      </div>
      <div class="add_info" v-if="add_companyTable===3">
        <div class="add_staff_info_titleAndInput">
          <span>企业名称</span>
          <el-input style="width: 200px" v-model="add_company_name"></el-input>
        </div>
        <div class="add_staff_info_titleAndInput">
          <span>简称</span>
          <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>
        </div>
        <div class="add_info_button">
          <el-button @click="addOEMcompany">添加</el-button>
          <el-button @click="Pan_add_companyTable">返回</el-button>
        </div>
      </div>
      <div class="add_info" v-if="add_device_type===1">
        <div class="add_staff_info_titleAndInput">
          <span>设备型号</span>
          <el-input style="width: 200px" v-model="add_device"></el-input>
        </div>
        <div class="add_info_button">
          <el-button @click="addDevice">添加</el-button>
          <el-button @click="Pan_add_device_type">返回</el-button>
        </div>
      </div>
      <div class="add_info" v-if="add_process===1">
        <div class="add_staff_info_titleAndInput">
          <span>制程工艺</span>
          <el-input style="width: 200px" v-model="add_process_input"></el-input>
        </div>
        <div class="add_info_button">
          <el-button @click="addProcess">添加</el-button>
          <el-button @click="Pan_add_process">返回</el-button>
        </div>
      </div>
      <div class="add_info" v-if="add_category===1">
        <div class="add_staff_info_titleAndInput">
          <span>竞品类别</span>
          <el-input style="width: 200px" v-model="add_category_input"></el-input>
        </div>
        <div class="add_info_button">
          <el-button @click="addCategory">添加</el-button>
          <el-button @click="Pan_add_category">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpUrl} from "../components/publics";

export default {
  name: "TableInputPhone",
  data() {
    return {
      jinxuan2: 1,
      jinxuan3: 3,
      jinxuan4: 5,
      selectFAB: "",
      add_companyTable: 0,
      add_staff_type: 0,
      add_company_name: "",
      add_company_abbreviation: "",
      companyStaffTable: "",
      companyStaffChoice: "",
      jinxuan: "",//判断是否禁选和传过来的UserID进行比较
      selectC: "",//单选框值
      companyTable: {},//公司列表
      FABcompanyTable: {},//FAB公司列表
      companyChoice: {},//公司列表
      OEMcompanyTable: {},//OEM公司列表
      OEMcompanyChoice: {},//公司列表
      FABcompanChoice: {},//FAB公司选择
      selectTable: {},//单选框列表
      deviceTable: {},//设备列表
      deviceChoice: "",//设备选择
      processTable: {},//制程工艺列表
      processChoice: "",//制程工艺列表
      categoryTable: {},//制程工艺列表
      categoryChoice: "",//制程工艺列表
      user_leave: {},
      staff_Name: "",
      staff_phone: "",
      staff_wechart: "",
      staff_companyChoice: "",
      staff_name_select: "",
      FABstaff_name_select: "",
      OEMstaff_name_select: "",
      FABcompanyStaffTable: {},//FAB员工列表
      OEMcompanyStaffTable: {},//OEM员工列表
      add_device_type: 0,
      add_process: 0,
      add_category: 0,
      add_device: "",
      add_process_input: "",
      add_category_input: "",
      selectOEM: "",
      selectOEMs: "",
      urlImage: '',
      fileList: [],
    };
  },
  watch: {
    companyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectcompanystaff(newName.id);
    },
    FABcompanChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectFABcompanystaff(newName.id);
    },
    OEMcompanyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectOEMcompanystaff(newName.id);
    },

  },
  mounted() {
    this.selectName();
    this.selectcompany();
    this.selectFABcompany();
    this.selectOEMcompany();
    this.selectdevice();
    this.selectprocess();
    this.selectCategory();
    this.getUser();
    this.jinxuan = this.$route.params.userId;
    console.log(this.$route.params)
  },
  methods: {
    bar_notShow() {
      this.PanDuanShou = false;
    },
    Second_jiage() {
      this.$router.push("/Main_menuPhone_JiaGeYuKuCun");
    },
    Second_ZhuDang() {
      this.$router.push("/ICChanPinXinXi_phone");
    },
    TableInputPhone() {
      this.$router.push("/TableInputPhone");
    },
    NeiBuXieTiao() {
      this.$router.push("/missionPhone");
    },

    FinancePhone() {
      this.$router.push("/FinancePhone");
    },
    DingDanZhongXin() {
      this.$router.push("/OrderPlone");
    },
    navbarShow() {
      if (this.PanDuanShou) {
        this.PanDuanShou = !this.PanDuanShou;
      } else {
        this.PanDuanShou = !this.PanDuanShou;
      }
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    clearInput() {
    },
    back() {
      this.$router.push("/Main_menuPhone");
    },
    urlChange(e) {
      console.log("url", e);
      if (e.code == 200) {
        this.urlImage = e.data.img;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
          `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
              files.length + fileList.length
          } 个文件`
      );
    },
    beforeRemove(file, fileList) {
    },
    beforeAvatarUpload(file) {
      console.log("file", file);
      // accept=".jpg,.jpeg,.png,.pdf,.JPG,.JPEG,.PDF,DOC"

      let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      var arr = [
        "png",
        "jpeg",
        "jpg",
        "pdf",
        "doc",
        "PNG",
        "JPEG",
        "JPG",
        "PDF",
        "DOC",
      ];
      let status = arr.findIndex((value, key) => {
        return fileName == value;
      });
      console.log("fileName", fileName, status);
      if (status == -1) {
        this.$message("上传文件只能是 png、jpeg、jpg、pdf、doc格式!");
        return false;
      }
      // if(!extension && !extension2) {
      //   this.$message({
      //     message: '上传文件只能是 xls、xlsx格式!',
      //     type: 'warning'
      //   });
      // }
    },
    //新增公司
    addcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/enterpriseAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                abbreviation: this.add_company_abbreviation,

              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增公司
    addFABcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/enterpriseEndAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                abbreviation: this.add_company_abbreviation,

              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectFABcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    //新增公司
    addOEMcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/equipmentSupplierAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                abbreviation: this.add_company_abbreviation,

              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectOEMcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增竞争公司销售人员
    addStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelAdd",
              this.$qs.stringify({
                enterprise_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                wechat: this.staff_wechart,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;

            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增竞争公司销售人员
    addFABStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelEndAdd",
              this.$qs.stringify({
                enterprise_end_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                wechat: this.staff_wechart,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompany()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增设备型号
    addDevice() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/deviceTypeAdd",
              this.$qs.stringify({
                device_type: this.add_device
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_device_type = 0;
              this.selectdevice()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增制程工艺
    addProcess() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/processTechnologyAdd",
              this.$qs.stringify({
                process_technology: this.add_process_input
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_process = 0;
              this.selectprocess()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    //新增竞品类别
    addCategory() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/categoryAdd",
              this.$qs.stringify({
                title: this.add_category_input
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_category = 0;
              this.selectCategory()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    //新增OEM销售人员
    addOEMStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelSupplierAdd",
              this.$qs.stringify({
                enterprise_supplier_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                wechat: this.staff_wechart,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompany()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    changeSelect() {
      this.$forceUpdate()
    },
    //判断是否打开新增竞争公司销售人员弹窗
    Pan_add_staff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.companyChoice).length != "") {
          this.add_staff_type = 1
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否打开新增FAB销售人员弹窗
    Pan_add_FABstaff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.FABcompanChoice).length != "") {
          this.add_staff_type = 2
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否新增竞争公司
    Pan_add_companyTable() {
      if (this.add_companyTable == 0) {
        this.add_companyTable = 1
      } else {
        this.add_companyTable = 0
      }
    },
    Pan_add_device_type() {
      if (this.add_device_type == 0) {
        this.add_device_type = 1
      } else {
        this.add_device_type = 0
      }
    },
    Pan_add_category() {
      if (this.add_category == 0) {
        this.add_category = 1
      } else {
        this.add_category = 0
      }
    },
    Pan_add_process() {
      if (this.add_process == 0) {
        this.add_process = 1
      } else {
        this.add_process = 0
      }
    },
    //判断是否打开新增OEM销售人员弹窗
    Pan_add_OEMstaff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.OEMcompanyChoice).length != "") {
          this.add_staff_type = 3
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否新增竞争公司
    change(params, val) {
      console.log(params, '这里测试的是parames');
      if (params == "a" && val != "") {
        this.staff_name_select = "";
      }
      if (params == "b" && val != "") {
        this.FABstaff_name_select = "";
      }
      if (params == "c" && val != "") {
        this.OEMstaff_name_select = "";
      }
    },
    //单选框赋值
    selectName() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/association `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.selectTable = response.data.data;
              // console.log(selectTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询公司列表
    selectcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询FAB列表
    selectFABcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise_end`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询OEM列表
    selectOEMcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/equipment_supplier`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询设备列表
    selectdevice() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/device_type`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.deviceTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询制程工艺列表
    selectprocess() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/process_technology`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.processTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //竞品类别列表
    selectCategory() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/category`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.categoryTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询竞争对手销售人员
    selectcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel?enterprise_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectFABcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_end?enterprise_end_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectOEMcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_supplier?enterprise_supplier_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询制程工艺
    updateAll() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/competitiveProductAdd",
              this.$qs.stringify({
                user_id: this.user_leave.id,
                quadrant_id: this.$route.params.userId,
                enterprise_id: this.companyChoice.id,
                enterprise_user_id: this.staff_name_select,
                enterprise_type: this.selectC,
                enterprise_end_id: this.FABcompanChoice.id,
                enterprise_end_user_id: this.FABstaff_name_select,
                enterprise_end_type: this.selectFAB,
                equipment_supplier_id: this.OEMcompanyChoice.id,
                equipment_supplier_user_id: this.OEMstaff_name_select,
                equipment_supplier_type: this.selectOEMs,
                device_type: "",
                process_technology: "",
                category: "",
                equipment_condition: "",
                personnel_relations: "",
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompany()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    // UpdateImg() {
    //   console.log(this.fileList)
    //   this.axios
    //       .post(httpUrl + `index.php/api/up_files/upload`,this.$qs.stringify({
    //           file:this.file
    //       }))
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message)
    //         }
    //         // this.$message("搜索成功");
    //         console.log("success", response.data);
    //       })
    //       .catch((error) => console.log(error, "error"));
    // },
  },
};
</script>

<style>
</style>
<style scoped>
.el-radio-group >>> .el-radio is-checked >>> .el-radio {
  margin-right: 15px;
}
.add_staff_info_titleAndInput {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  text-align: right;

}

.add_staff_info_titleAndInput span {
  width: 22%;
  text-align: right;
}

.add_info {
  width: 85%;
  height: 35%;
  background: #42b983;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 6px;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.heads_menus {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu_icon img {
  width: 24px;
}

.heads {
  padding-top: 40px;
  flex-direction: column;
  width: 42%;
  justify-content: space-around;
  display: flex;
  align-items: center;
  height: 300px;
  background-color: #ffffff;
  position: fixed;
  right: 0;
  z-index: 98;
  border-radius: 4px;
  box-shadow: 2px 1px 6px 6px #ccc;
}

.heads span {
  color: #000;
  font-size: 13px;
  line-height: 20px;
  font-weight: 250;
}

.heads_button {
  width: 70%;
  height: 40px;
  display: flex;

  align-items: center;
  justify-content: center;
}

.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu_icon img {
  width: 24px;
}

.input_left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}

.all_part {
  min-height: 100vh;
  background-color: #f2f2f2;
}

.head {
  width: 100%;
  /* justify-content: space-between; */
  display: flex;
  align-items: center;
  height: 45px;
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  position: fixed;
  z-index: 99;
}

.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}

.back img {
  margin-top: 5px;
}

.titleName {
  display: flex;
  justify-content: center;
}

.back {
  margin: 0 5px;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 5px;

  height: 32%;
}

.all_input_top {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.Ctrl_padding {
  height: 40%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_top_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_all {
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 10px;
}

.all_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 15px;
}

.input {
  margin-bottom: 10px;
}

.all_key {
  display: flex;
  flex-direction: row;
}

.two_spans {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: aqua;
}

.Key {
  width: 48%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 8pt;
  margin-bottom: 4px;
  justify-content: space-between;
}

.serch {
  width: 60%;
}

.list_div {
  margin-top: 20px;
  background: #ffffff;
  background-image: url("../assets/table_logo2.png");
  border-radius: 5px;
  padding: 10px 7px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}

.titleAndicon {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.title_icon {
  margin-right: 20px;
}

.sousuoButton {
  position: relative;
}

.sousuo_icon {
  top: 16px;
  left: 16px;
  position: absolute;
}

.ChongZhi {
  position: relative;
}

.icon_chong {
  top: 16px;
  left: 10px;
  position: absolute;
}

.ShouQi {
  margin-bottom: 10px;
}

.icon_Shou {
  top: 14px;
  left: 12px;
  position: absolute;
}

.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}

.all_spans1 {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.all_spans {
  padding: 0 10px;
}

.titles {

  margin-top: 10px;
  display: flex;
  margin-bottom: 10px;

}

.ss {
  height: 55px;
}

.XinJiuBianHao {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.second_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.double_span {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.double_spans {
  width: 48%;
}

.list_div_divs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}

.list_div {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding: 6px 14px;
  /* background-image: url(./../assets/img_cx_sylogo@2x.png); */
  background-size: 190px 102px;
}

.list_div_p_span {
  color: #008de3;
}

.list_div_span {
  color: #222222;
}

.list_div_p {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: left;
  margin: 6.5px 0;
}

.all_input_bottom {
  flex-direction: column;
  height: 20%;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
}

.input_left div {
  margin-bottom: 20px;
}

.all_control {
  background: #ffffff;
  margin-bottom: 20px;
  padding: 0 5px;
}

.all_control_input_button {
  display: flex;
  flex-direction: column;
}

.type_selection {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.Type_title {
  font-weight: 600;
  text-align: left;
  margin-bottom: 20px;
}

.title_input_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 20px;
}
.title_input_buttons{
  margin-bottom: 20px;
}
</style>